import React from "react";

import Izvjesce from "./Forms/Izvjesce";
import PolicaOsiguranja from "./Forms/PolicaOsiguranja";
import Revizija from "./Forms/Revizija";
import RaskidUgovora from "./Forms/RaskidUgovora";
import Revidirani from "./Forms/Revidirani";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";

const FormSection = ({
  values,
  clicked,
  handleInputChange,
  handleDateChange,
  handleSingleFileUpload,
  selectedRecord,
  handleRadioButton,
  update,
  hideUpdateModal,
  handleUpdateSubmit,
  downloadAttachments,
  removeAttachment,
  handleMultiFileUpload,
  handleNumberInput,
  handleDecimalNumberInput
}) => {
  return (
    <div className="row justify-content-center" key={"form"}>
      <div className="col-lg-5 col-md-6  align-self-center">
        <div
          className="card p-4"
          style={{
            border: "none",
            boxShadow: "0px 20px 20px 0px rgba(0,0,0,.1)",
          }}
        >
          {selectedRecord == "1" && (
            <PolicaOsiguranja
              handleSingleFileUpload={handleSingleFileUpload}
              handleMultiFileUpload={handleMultiFileUpload}
              handleDateChange={handleDateChange}
              handleInputChange={handleInputChange}
              values={values}
              update={update}
              downloadAttachments={downloadAttachments}
              removeAttachment={removeAttachment}
              handleNumberInput={handleNumberInput}
              handleDecimalNumberInput={handleDecimalNumberInput}
            />
          )}
          {selectedRecord == "2" && (
            <Izvjesce
              handleSingleFileUpload={handleSingleFileUpload}
              handleMultiFileUpload={handleMultiFileUpload}
              handleDateChange={handleDateChange}
              handleInputChange={handleInputChange}
              values={values}
              update={update}
              handleRadioButton={handleRadioButton}
              downloadAttachments={downloadAttachments}
              removeAttachment={removeAttachment}
              handleNumberInput={handleNumberInput}
            />
          )}
          {selectedRecord == "3" && (
            <Revizija
              handleSingleFileUpload={handleSingleFileUpload}
              handleDateChange={handleDateChange}
              handleMultiFileUpload={handleMultiFileUpload}
              handleInputChange={handleInputChange}
              update={update}
              values={values}
              downloadAttachments={downloadAttachments}
              removeAttachment={removeAttachment}
              handleNumberInput={handleNumberInput}
            />
          )}
          {selectedRecord == "4" && (
            <RaskidUgovora
              handleSingleFileUpload={handleSingleFileUpload}
              handleDateChange={handleDateChange}
              handleInputChange={handleInputChange}
              handleMultiFileUpload={handleMultiFileUpload}
              update={update}
              values={values}
              downloadAttachments={downloadAttachments}
              removeAttachment={removeAttachment}
              handleNumberInput={handleNumberInput}
            />
          )}
          {selectedRecord == "5" && (
            <Revidirani
              handleSingleFileUpload={handleSingleFileUpload}
              handleDateChange={handleDateChange}
              handleInputChange={handleInputChange}
              handleMultiFileUpload={handleMultiFileUpload}
              update={update}
              values={values}
              downloadAttachments={downloadAttachments}
              removeAttachment={removeAttachment}
              handleNumberInput={handleNumberInput}
              handleDecimalNumberInput={handleDecimalNumberInput}
            />
          )}
          {update && (
            <>
              <br></br>
              <div className="row" key={"button"}>
                <div className="col-md-6">
                  <ButtonComponent
                    onClick={handleUpdateSubmit}
                    variant="primary"
                    block
                    disabled={clicked === true ? true : false}
                  >
                    Ažuriraj
                  </ButtonComponent>
                </div>
                <div className="col-md-6">
                  <ButtonComponent
                    block
                    onClick={hideUpdateModal}
                    variant="danger"
                  >
                    Zatvori
                  </ButtonComponent>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormSection;
